import React, { Component } from "react";

import settings from "../settings.js";
import { Link } from "react-router-dom";

import Scrollbars from "react-custom-scrollbars";
import Returnnotification from "./returnnotification.js";

class ReturnNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true, data: [] };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url +
        "get_retouren/" +
        window.sessionStorage.getItem("sid"),
      {
        method: "POST",
        body: JSON.stringify({
          showAll: false,
          limit: 8,
          offset: 0,
        }),
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.result && Array.isArray(response.returns)) {
          this.setState({
            data: response.returns,
            isLoading: false,
          });
        }
      })
      .catch((error) => console.error("Error:", error));
  }

  render() {
    return (
      <div className="gridItem">
        <div className="gridHeader">
          {/*
          <div className="gridHeaderIcon">
            <img src={Check} alt="" />
          </div>
          */}
          <div className="gridHeaderTitle">Retouren</div>
          {this.state.data.length > 0 && (
            <div className="gridHeaderCount returns">
              {this.state.data.length}
            </div>
          )}
          <div className="gridHeaderAll">
            <Link to={"/retouren"} className="">
              Bekijk alle
            </Link>
          </div>
        </div>
        {this.state.isLoading ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows loading"></div>
          </Scrollbars>
        ) : this.state.data.length > 0 ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              {this.state.data.map((retour, index) => (
                <Returnnotification key={retour.return_id} retour={retour} />
              ))}
            </div>
          </Scrollbars>
        ) : (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              <Returnnotification empty={true} />
            </div>
          </Scrollbars>
        )}
      </div>
    );
  }
}

export default ReturnNotifications;
